import { Input } from "antd";
import styled from "styled-components";

export const EmbedScript = styled(Input.TextArea)`
  height: 20rem !important;
  resize: none;
  cursor: pointer;
`;
